import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { AddSubtaskDialogComponent } from 'src/app/core/dialogs/add-subtask-dialog/add-subtask-dialog.component';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { TaskService } from 'src/app/service/task.service';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BoardsService } from 'src/app/service/boards.service';
import { GridOptions } from 'ag-grid-community';
export interface DialogData {
  performAction: string;
  placeholder: string;
  taskID;
  placeholderDesc: string;
  subtask_name: string;
  placeholderOP;
  subtask_id;
  page;
}
export interface deleteSubTaskData {
  page;
  subtask_id;
  subtaskName;
}
@Component({
  selector: 'app-subtask',
  templateUrl: './subtask.component.html',
  styleUrls: ['./subtask.component.scss'],
  standalone: false,  // NOSONAR
})
export class SubtaskComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any
  gridOptions: GridOptions;
  setPagination = 'true';
  defaultColDef;
  paginationPageSize: number = 30;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  @ViewChild('agGrid', { static: true }) agGrid
  columnDefs;
  rowData;
  icons;
  context: any;
  rowCount;
  successMessage = '';
  errorMessage = '';
  selectedRows: any = [];
  taskID;
  taskData;
  maintaskDesc;
  taskNameTitle;
  dynamicHeight: number;
  totalRecords = 0; // Replace with your actual total records count
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ]
  constructor(public dialog: MatDialog, private readonly taskService: TaskService,
    private readonly subtaskService: TaskService, private readonly route: ActivatedRoute,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly router: Router, private readonly location: Location,
    private readonly boardService: BoardsService) {
    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.context = {
      componentParent: this
    };
    this.columnDefs = [
      {
        headerName: "DESCRIPTION", headerClass: "description", field: "description",
        cellClass: "cell_description", width: 1000,
        sortable: true, unSortIcon: true, autoHeight: true,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
      },
      {
        headerName: "ACTIONS", field: "subtask_action",
        width: 120, headerClass: "editdelete",
        cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
            // do something
          }
        }
      }];
    this.gridOptions = { suppressRowClickSelection: true }
    this.icons = {
      sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
    };
    this.defaultColDef = {
      minWidth: 100,
      wrapText: true,
      floatingFilter: true
    };
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }
  goToLastPage() { this.gridApi.paginationGoToLastPage() }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }
  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }
  onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); }
  getCurrentPage(): boolean {
    this.currentPageNo = this.agGrid.api?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  loadData() {
    this.ngxUiLoaderService.start("loader-01");
    // reading from query params
    // this.taskID = this.route.snapshot.queryParamMap.get('taskid');
    // this.taskNameTitle = this.route.snapshot.queryParamMap.get('taskidtitle');
    // reading from location state
    const data: any = this.location.getState();
    console.info("the data", data);
    if (data.taskid) {
      this.taskID = data.taskid;
      this.taskNameTitle = data.taskidtitle;
      this.maintaskDesc = this.taskNameTitle;
      this.ngxUiLoaderService.start("loader-01");
      //API Integration
      this.rowData = [];
      this.subtaskService.getsubtaskDetails(this.taskID).subscribe(result => {
        console.info("calling getdetails")
        if (result?.length > 0) {
          this.rowData = result;
          this.rowCount = this.rowData.length;
        }
        else {
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
        }
        this.ngxUiLoaderService.stop("loader-01");
      });
    }
    // route to task screen
    else {
      this.router.navigateByUrl('/task');
    }
  }
  ngOnInit(): void {
    // clear contingency data
    sessionStorage.removeItem('contData');
    this.boardService.deleteContingenyList().subscribe(_result => {
      // contingency list deleted
    });
    this.loadData();
  }
  refreshData() {
    this.loadData();
  }
  openDialog(): void {
    console.info("open dialog");
    const dialogRef = this.dialog.open(AddSubtaskDialogComponent, {
      disableClose: true,
      width: '503px',
      data: { performAction: 'AddCell', placeholder: '', taskID: this.taskID }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'AddCell') { // NOSONAR
        const dataArr = {
          "taskID": null,
          "description": result.data1,
          "categoriesDTO": null,
          "opDTO": {
            "url": null,
            "opID": result.data2,
            "description": result.data3
          },
          "parentID": this.taskID
        };
        this.subtaskService.addsubtask(dataArr).subscribe(result => {
          if (!result) {
            this.loadData();
            this.errorMessage = 'SubTask already exists!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
          else if (result) {
            this.loadData();
            this.successMessage = 'SubTask added successfully!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
        });
      }
    });
  }
  editSubTaskRow(val) {
    let id;
    let subtask_name;
    let OPID;
    let taskDesc;
    this.rowData.filter(x => x.taskID == val).forEach(e => { // NOSONAR
      id = e.taskID;
      subtask_name = e.description;
      OPID = e.opDTO.opID;
      console.info("the mann", e);
    });
    const dialogRef = this.dialog.open(AddSubtaskDialogComponent, {
      disableClose: true,
      width: '503px',
      data: {
        performAction: 'EditCell', placeholderDesc: subtask_name, taskID: this.taskID,
        placeholderOP: OPID, page: 'Sub Task', subtask_id: id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'EditCell') { // NOSONAR
        //API Integration
        const dataArr = {
          "taskID": id,
          "description": result.data1,
          "categoriesDTO": null,
          "opDTO": {
            "url": null,
            "opID": result.data2,
            "description": result.data3
          },
          "parentID": this.taskID
        };
        this.ngxUiLoaderService.start("loader-01");
        this.subtaskService.editsubtask(dataArr).subscribe(_result => {
          this.successMessage = 'SubTask updated successfully!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          //fetch latest row data after editing
          this.loadData();
          // }
        });
      }
    });
  }
  deleteSubTaskRow(val) {
    console.info("row data", this.rowData);
    let id;
    let subtask_name;
    this.rowData.filter(x => x.taskID == val).forEach(e => { // NOSONAR
      id = e.taskID;
      subtask_name = e.description;
    });
    const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
      disableClose: true,
      width: '510px',
      data: { subtask_id: id, subtaskName: subtask_name, page: "subtask" }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.info('The dialog was closed', result);
      console.info("data to be deleted:", result.data);
      const deletejson = {
        "subtaskID": result.data
      }
      this.deleteRecords(deletejson);
    });
  }
  deleteRecords(dataArr) {
    this.ngxUiLoaderService.start("loader-01");
    this.subtaskService.deletesubtask(dataArr).subscribe(_result => {
      this.successMessage = 'Deleted Row(s) Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
      //fetch latest row data after deleting
      this.loadData();
    });
  }
  onback() {
    this.router.navigateByUrl('/task');
  }
}